import React, { useState, useEffect } from 'react'
import InventoryCountForm from './InventoryCountForm ';
import { Column, Row } from 'simple-flexbox';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Toolbar, InputAdornment } from '@material-ui/core';
import useTable from "../../../utilities/useTable";
import { ToastContainer } from 'react-toastify';
import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import Moment from 'react-moment';
import { Search } from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddInventoryCount from './AddInventoryCount';
import InventoryCorrection from './InventoryCorrection';

const useStyles = makeStyles(theme => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3)
    },
    searchInput: {
        width: '75%'
    },
    newButton: {
        position: 'absolute',
        right: '10px'
    }
}))


const headCells = [
    { id: 'count', label: 'Count' },
    { id: 'locationName', label: 'Location Name' },
    { id: 'productName', label: 'Product Name' },
    { id: 'firstName', label: 'First Name' },
    { id: 'dateCounted', label: 'Date Counted' },
    { id: 'actions', label: 'Actions', disableSorting: true }
]

export function InventoryCount({ locations, LoadInventoryCount, inventoryCountList, products,userId }) {

    const classes = useStyles();
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [openPopup, setOpenPopup] = useState(false)
    const [inventoryCount, setInventoryCount] = useState(false)
    const [addOpenPopup, setAddOpenPopup] = useState(false)
    const [correctionOpenPopup, setCorrectionOpenPopup] = useState(false)
    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(inventoryCountList, headCells, filterFn);

    useEffect(() => {
        LoadInventoryCount(userId)
        return () => {

        }
    }, [])

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {

                if (target.value === "")
                    return items;
                else
                    return items.filter(x => x.locationName.toLowerCase().includes(target.value))
            }
        })
    }

    





    const openInPopup = item => {
        setRecordForEdit(item)
        setOpenPopup(true)
    }

    const openInCount = item => {
        setRecordForEdit(item)
        setInventoryCount(true)
    }


    const onDelete = id => {
     //   DeleteLocation(id)
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
    }
    return (

        <div style={{  }}>
            <Column flexGrow={1}>
                <StatComponent />
                <ToastContainer />
               
                <div style={{ margin: '10px 0px 0px 80px', width: '95%', }}>
                    <Controls.Input
                        label="Search Inventory Count by Location Name"
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (<InputAdornment position="start">
                                <Search />
                            </InputAdornment>)
                        }}
                        onChange={handleSearch}
                        watcherGetInventoryCountSaga />
                </div>
                
                <Paper className={classes.pageContent}>
                    <h2>Inventory Count</h2>

                    <Toolbar>
                        <Controls.Button
                            text="Add Inventory Count"
                            variant="outlined"
                            startIcon={<AddIcon />}
                            className={classes.newButton}
                            onClick={() => { setOpenPopup(true); setRecordForEdit(null); }}
                        />
                    </Toolbar>
            
                    <TblContainer>
                        <TblHead />
                        <TableBody>
                            {

                                recordsAfterPagingAndSorting().map(item =>
                                (<TableRow key={item.dateCounted}>
                                     <TableCell>{item.count}</TableCell>
                                    <TableCell>{item.locationName}</TableCell>
                                    <TableCell>{item.productName}</TableCell>
                                    <TableCell>{item.lastName}</TableCell>
                                    <TableCell><Moment format="YYYY/MM/DD:HH:MM:SS">{item.dateCounted}</Moment></TableCell>

                                    <TableCell>
                                        <Controls.ActionButton
                                            color="primary"
                                            onClick={() => {
                                                openInCount(item)
                                            }}>
                                            <EditOutlinedIcon fontSize="small" />
                                        </Controls.ActionButton>
                                    </TableCell>

                                </TableRow>)
                                )
                            }
                        </TableBody>
                    </TblContainer>
                    <TblPagination />
                </Paper>

                <Popup
                    title="ADD INVENTORY COUNT"
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >

                    <AddInventoryCount
                        recordForEdit={recordForEdit}
                        setOpenPopup={setOpenPopup}
                        locations={locations}
                        products={products} />
                </Popup>
                <Popup
                    title="Inventory Count Form"
                    inventoryCount={inventoryCount}
                    setInventoryCount={setInventoryCount}
                >
                    <InventoryCountForm
                        recordForEdit={recordForEdit}
                        setInventoryCount={setInventoryCount}
                        locations={locations}
                        products={products}
                    />
                </Popup>

                <Notification
                    notify={notify}
                    setNotify={setNotify}
                />
                <ConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Column>

        </div>

    )
}





function mapStateToProps(state) {
    console.log(state)
    return {
       
        locations: state.locationReducer.locationDrop,
        products:state.productReducer.productList,
        userId:state.persistReducer.userId,
        inventoryCountList:state.inventoryReducer.inventoryCountList
    };
}
const mapDispatchToProps = (dispatch) => ({

   
    LoadInventoryCount(payload) {
        dispatch({ type: "LOAD_INVENTORY_COUNT", payload });
    },
 
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InventoryCount);